import React from "react";
import SuiResult from "./components/SuiResult/SuiResult";

import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";

import {
  ErrorBoundary,
  Facet,
  SearchProvider,
  SearchBox,
  Results,
  PagingInfo,
  ResultsPerPage,
  Paging,
  //Sorting,
  WithSearch
} from "@elastic/react-search-ui";
import { Layout } from "@elastic/react-search-ui-views";
import "@elastic/react-search-ui-views/lib/styles/styles.css";
import "./custom.css";

import {
  buildAutocompleteQueryConfig,
  buildFacetConfigFromConfig,
  buildSearchOptionsFromConfig,
  //buildSortOptionsFromConfig,
  getConfig,
  getFacetFields,
  stripHtmlTags,
  removeUnderscore,
  decodeHtmlEntities,
} from "./config/config-helper";

const { hostIdentifier, searchKey, endpointBase, engineName } = getConfig();
const connector = new AppSearchAPIConnector({
  searchKey,
  engineName,
  hostIdentifier,
  endpointBase
});
const config = {
  searchQuery: {
    facets: buildFacetConfigFromConfig(),
    ...buildSearchOptionsFromConfig()
  },
  autocompleteQuery: buildAutocompleteQueryConfig(),
  apiConnector: connector,
  alwaysSearchOnInitialLoad: true
};

const CustomResultView = ({ result, onClickLink, filters = [] }) => {

  const cleanTitle = result.clean_title && result.clean_title.snippet ? decodeHtmlEntities(stripHtmlTags(result.clean_title.snippet)) : '';

  return (
    <SuiResult 
      result={result} 
      cleanTitle={cleanTitle} 
      onClickLink={onClickLink} 
      decodeHtmlEntities={decodeHtmlEntities} 
    />
  );
};

export default function App() {
  return (
    <SearchProvider config={config}>
      <WithSearch mapContextToProps={({ wasSearched, state }) => ({ wasSearched, state })}>
        {({ wasSearched, state }) => {
          const hasServicesFilter = state && state.filters && state.filters.some(filter => filter.field === 'result_type' && filter.value === 'Services');

          return (
            <div className="App">
              <ErrorBoundary>
                <Layout
                  header={<SearchBox autocompleteSuggestions={true} />}
                  sideContent={
                    <div>
                      {/* {wasSearched && (
                        <Sorting
                          label={"Sort by"}
                          sortOptions={buildSortOptionsFromConfig()}
                        />
                      )} */}
                      {getFacetFields().map(field => {
                        if (["service_area", "service_focus"].includes(field) && !hasServicesFilter) {
                          return null; // Do not render the facet
                        }
                        return <Facet key={field} field={field} label={removeUnderscore(field)} />;
                      })}
                    </div>
                  }
                  bodyContent={
                    <Results
                      resultView={CustomResultView}
                      titleField="clean_title"
                      urlField="url"
                      thumbnailField={getConfig().thumbnailField}
                      shouldTrackClickThrough={true}
                    />
                  }
                  bodyHeader={
                    <React.Fragment>
                      {wasSearched && <PagingInfo />}
                      {wasSearched && <ResultsPerPage />}
                    </React.Fragment>
                  }
                  bodyFooter={<Paging />}
                />
              </ErrorBoundary>
            </div>
          );
        }}
      </WithSearch>
    </SearchProvider>
  );
}



/* function shouldShowFacet(field, filters) {
  if ('result_type' === 'Services') {
    return filters.some(filter => filter.field === 'result_type' && filter.value === 'Services');
  }
  return true; // Show all other facets by default
} */